import angular from 'angular';

(function () {
    'use strict';

    // Component DEF
    var kissReferentialReducedSection = {
        controller: 'ReferentialReducedSectionCtrl as vm',
        templateUrl: require('./referential-reduced-section.html'),
        bindings: {
            section: '<',
        }
    };
    // Add to the App
    angular.module('app.principal').component('kissReferentialReducedSection', kissReferentialReducedSection);
})();
